/**
 * 统计导出任务细粒度步数（用于进度条百分比）
 */
export function countExportWorkSteps(exportSheets = []) {
  let steps = 3 // 准备 / 生成文件 / 收尾
  exportSheets.forEach((sheet) => {
    if (sheet.category === 'traffic') {
      const configs = sheet.channelConfigs?.length
        ? sheet.channelConfigs
        : (sheet.channels || ['__overall__']).map((ch) => ({
          channel: ch,
          metrics: sheet.metrics || ['pv', 'uv']
        }))
      configs.forEach((cfg) => {
        steps += 1
        if ((cfg.metrics || []).some((m) => ['sumStayTime', 'avgStayTime'].includes(m))) {
          steps += 1
        }
      })
      steps += 1
    } else {
      const channels = sheet.channels?.length || 1
      const behaviors = (sheet.behaviors || []).length
      const merges = (sheet.mergedBehaviors || []).filter((m) => m.behaviors?.length)
      steps += channels * Math.max(behaviors, 0)
      merges.forEach((mg) => {
        steps += 1
        if (mg.keepOriginal) steps += channels * (mg.behaviors?.length || 0)
      })
      steps += 1
    }
  })
  return Math.max(steps, 5)
}

/**
 * 绑定到 reactive progress 对象（需含 percentage/message/current/total/logs 等字段）
 */
export function createExportProgressController(progress) {
  let total = 5
  let current = 0

  function pushLog(text, done = false) {
    if (!Array.isArray(progress.logs)) progress.logs = []
    progress.logs.unshift({ text, done, ts: Date.now() })
    if (progress.logs.length > 80) progress.logs.length = 80
  }

  function sync() {
    progress.total = total
    progress.current = current
    progress.remaining = Math.max(total - current, 0)
    const pct = Math.min(
      current >= total ? 100 : 99,
      Math.round((current / Math.max(total, 1)) * 100)
    )
    progress.percentage = pct
    if ('pct' in progress) progress.pct = pct
  }

  return {
    start(sheetList, message = '准备导出...') {
      total = countExportWorkSteps(sheetList)
      current = 0
      progress.status = ''
      progress.currentLabel = ''
      progress.logs = []
      progress.message = message
      pushLog(message, false)
      sync()
    },
    /** 报告当前步骤（可选增加步数） */
    report(message, { label = '', advance = 0, logDone = false } = {}) {
      if (advance > 0) current = Math.min(current + advance, total)
      progress.message = message
      if (label) progress.currentLabel = label
      pushLog(message, logDone)
      sync()
    },
    /** 完成一步 */
    stepDone(message, label = '') {
      current = Math.min(current + 1, total)
      progress.message = message
      if (label) progress.currentLabel = label
      pushLog(message, true)
      sync()
    },
    finish(status, message) {
      current = total
      progress.status = status
      progress.message = message
      progress.percentage = 100
      if ('pct' in progress) progress.pct = 100
      progress.remaining = 0
      pushLog(message, status === 'success')
    }
  }
}
